
import React from 'react';
import {DashboardContainer} from "../../../funcs/utils";
import { connect } from 'react-redux';
import {centsToString} from "../../../../lib/currency-utils";
import { timestamp_sec_to_mmddyy_hhmmss } from "../../../../lib/time";

const PaymentDone_ = props => {

  let payment;
  const payment_id = props.user.invite.payment_id;
  const dwolla = props.dwolla['0000'];
  if (payment_id in dwolla.payments) {
    payment = dwolla.payments[payment_id];
  } else if (payment_id in dwolla.completed_payment_ids) {
    payment = dwolla.completed_payment_ids[payment_id];
  } else if (payment_id in dwolla.queued_debits) {
    payment = dwolla.queued_debits[payment_id];
  }
  const date_str = timestamp_sec_to_mmddyy_hhmmss(payment.requested_sec || payment.queued_sec);
  const amt = centsToString(payment.amt_cents);
  const trustee_name = props.user.invite.trustee_name;
  const bold_style = {
    fontWeight: "bold",
  }
  return (
    <DashboardContainer
      client={props.client}
      title={"Thank You!"}>
      <div style={{fontSize: "1.2rem"}}>
        <span>You contributed </span>
        <span style={bold_style}>{amt}</span>
        <span> to </span>
        <span style={bold_style}>{trustee_name}</span>
        <span>'s account on </span>
        <span style={bold_style}>{date_str}</span>.
      </div>
    </DashboardContainer>
  )
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    dwolla: state.dwolla,
    user: state.user,
  };
}

const PaymentDone = connect(mapStateToProps, mapDispatchToProps)(PaymentDone_);

export { PaymentDone };
